<template>
  <MarketTypeTable
      :items="items"
      @operation="onOperation"
  />
</template>

<script>
  import MarketTypeTable from './MarketTypeTable.vue';
  import {API} from "../../../../helpers/api-endpoints";
  import {Operations} from "../../../../helpers/roles";

  export default {
    name: 'MarketTypeList',
    components: { MarketTypeTable },
    data() {
      return {
        items: [],
      };
    },
    mounted() {
      this.load();
    },
    methods: {
      async load() {
        this.$loading(true);
        try {
          const { data } = await this.$http.post(API.MARKET_TYPE_SEARCH, {
            offset: 0,
            max: 50,
            selectFields: ['*']
          });
          this.items = data.resultList || [];
        } finally {
          this.$loading(false);
        }
      },

      onOperation({ type, payload }) {
        switch (type) {
          case Operations.CREATE:
            this.$router.push({ name: 'adminMarketTypeCreate' });
            break;

          case Operations.VIEW:
            this.$router.push({
              name: 'adminMarketTypeView',
              params: { code: payload }
            });
            break;
        }
      }
    }
  };
</script>
